import * as React from "react";
import { Container } from "@material-ui/core";
import * as Styles from "./styles/ContainerStyles";
import MyAccountContainer from "../my-account/MyAccountContainer";
import { SecureArea } from "../authentication/SecureArea";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../services/TelemetryService";

function MyAccount() {
  const classes = Styles.ContainerStyles();

  return (
    <SecureArea>
      <Container fixed className={classes.container}>
        <MyAccountContainer />
      </Container>
    </SecureArea>
  );
}

export default withAITracking(reactPlugin, MyAccount, "MyAccount");
